module.exports = __webpack_public_path__ + "img/group-372.68b3e88d.png";